<template>
  <div>
    <nav
      class="navbar navbar-expand-md navbar-dark bg-dark fixed-top navbar-overflow"
      v-if="getCurrentUser"
    >
      <a class="navbar-brand" href="/">{{ $t('title') }}</a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarDashboard"
        aria-controls="navbarDashboard"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarDashboard">
        <div class="navbar-nav mr-auto">
          <li class="nav-item active">
            <span class="text-muted">{{ getCurrentUser.email }}</span>
            <a href="#" @click="onLanguageChange('fr')">&#x1F1EB;&#x1F1F7;</a>
            <a href="#" class="ml-1" @click="onLanguageChange('en')">&#x1F1EC;&#x1F1E7;</a>
            <a href="#" class="ml-1" @click="onLanguageChange('de')">&#x1F1E9;&#x1F1EA;</a>
          </li>

          <li class="nav-item active dropdown" v-if="getCurrentUser.userRole.name === 'partner'">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {{ $t('navbar.tab.dashboards') }}
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <a
                :class="
                  dashboard.id == currentDashboardId ? 'dropdown-item active' : 'dropdown-item'
                "
                v-for="dashboard in getCurrentUser.tabs[0].dashboards"
                :href="'/dashboard/' + dashboard.id"
                :key="dashboard.id"
                >{{ dashboard.titles[$locale] }}</a
              >
              <div class="dropdown-divider"></div>
              <a
                class="dropdown-item"
                href="#"
                data-toggle="modal"
                data-target="#createNewDashboardModal"
                >{{ $t('dashboard.create') }}</a
              >
            </div>
          </li>

          <div v-if="getCurrentUser.userRole.name !== 'partner'">
            <li class="nav-item active dropdown" v-for="tab in getCurrentUser.tabs" :key="tab.id">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {{ tab.titles[$locale] }}
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <a
                  :class="
                    dashboard.id == currentDashboardId ? 'dropdown-item active' : 'dropdown-item'
                  "
                  v-for="dashboard in tab.dashboards"
                  :href="'/dashboard/' + dashboard.id"
                  :key="dashboard.id"
                  >{{ dashboard.titles[$locale] }}</a
                >
                <div class="dropdown-divider"></div>
                <a
                  class="dropdown-item"
                  href="#"
                  data-toggle="modal"
                  data-target="#createNewDashboardModal"
                  @click="onDisplayCreationModal(tab)"
                  >{{ $t('dashboard.create') }}</a
                >
              </div>
            </li>
          </div>

          <!-- Comments -->
          <li class="nav-item active">
            <a class="nav-link" href="/comments"
              ><i class="fas fa-comments mr-2"></i>{{ $t('comments') }}</a
            >
          </li>

          <!-- Stream Profile -->
          <li class="nav-item active" v-if="getCurrentUser.userRole.name !== 'partner'">
            <a class="nav-link" :href="'/stream/profiles'"
              ><span><i class="fas fa-stream mr-2"></i>{{ $t('stream_profiles.title') }}</span></a
            >
          </li>

          <!-- Survey -->
          <li class="nav-item active" v-if="getCurrentUser.userRole.name !== 'partner'">
            <a class="nav-link" :href="'/survey'"
              ><span><i class="fas fa-question mr-2"></i>{{ $t('survey') }}</span></a
            >
          </li>

          <li
            class="nav-item active"
            v-if="getCurrentUser.userRole.name === 'partner' && showSurveyForPartner"
          >
            <a class="nav-link" :href="'/survey'"
              ><span><i class="fas fa-question mr-2"></i>{{ $t('survey') }}</span></a
            >
          </li>

          <!-- Map -->
          <li class="nav-item active" v-if="getCurrentUser.userRole.name !== 'partner'">
            <a class="nav-link" :href="'/maps'"
              ><span><i class="fas fa-map mr-2"></i>{{ $t('maps') }}</span></a
            >
          </li>

          <li
            class="nav-item active"
            v-if="getCurrentUser.userRole.name === 'partner' && showMapForPartner"
          >
            <a class="nav-link" :href="'/maps'"
              ><span><i class="fas fa-map mr-2"></i>{{ $t('maps') }}</span></a
            >
          </li>

          <!-- Download -->
          <li class="nav-item active" v-if="getCurrentUser.userRole.name !== 'partner'">
            <a class="nav-link" href="#" data-toggle="modal" data-target="#downloadFileModal"
              ><i class="fas fa-download mr-2"></i>{{ $t('navbar.tab.download') }}</a
            >
          </li>

          <!-- Admin -->
          <li
            class="nav-item active dropdown"
            v-if="getCurrentUser.userRole.name === 'administrator'"
          >
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="fa fa-cog mr-2"></i>{{ $t('navbar.tab.admin') }}
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <a class="dropdown-item" href="/admin/users">{{ $t('users') }}</a>
              <a class="dropdown-item" href="/admin/sites">{{ $t('sites') }}</a>
            </div>
          </li>

          <!-- Exploitation -->
          <li class="nav-item active dropdown" v-if="getCurrentUser.userRole.name !== 'partner'">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="fas fa-toolbox mr-2"></i>{{ $t('navbar.tab.exploitation') }}
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <a class="dropdown-item" href="/battery/informations/battery_lifetime">{{
                $t('battery.informations')
              }}</a>
              <a class="dropdown-item" href="/sessions/device/all">{{ $t('device_sessions') }}</a>
            </div>
          </li>

          <!-- Email support -->
          <li class="nav-item active" v-if="getCurrentUser.userRole.name !== 'partner'">
            <a class="nav-link" :href="'/support/email'"
              ><span><i class="fas fa-envelope mr-2"></i>{{ $t('support.email') }}</span></a
            >
          </li>
        </div>
        <div class="my-2 my-lg-0">
          <button class="btn my-2 my-sm-0" type="button" @click="signOut">
            {{ $t('sign_out') }}
          </button>
        </div>
      </div>
    </nav>

    <!-- Dashboard creation modal -->
    <div
      class="modal fade"
      id="createNewDashboardModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="createNewDashboardModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="confirmDeleteModalLabel">{{ $t('dashboard.create') }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group row">
              <div class="col-sm-3">
                <select id="inputTitleLang" class="form-control" v-model="dashboardLocale">
                  <option v-for="(value, key) in dashboardForm.titles" :value="key" :key="key">
                    {{ $t('modal.title') }} - {{ key.toUpperCase() }}
                  </option>
                </select>
              </div>
              <div class="col-sm-9" v-if="dashboardForm.titles">
                <input
                  type="title"
                  :maxlength="maxCharacters"
                  class="form-control"
                  id="inputDashboardTitle"
                  :placeholder="$t('modal.title', dashboardLocale)"
                  v-model="dashboardForm.titles[dashboardLocale]"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              {{ $t('cancel') }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              @click="onCreateDashboard"
            >
              {{ $t('confirm') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Download file modal -->
    <div
      class="modal fade"
      id="downloadFileModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="downloadFileModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="downloadFileModalLabel">{{ $t('navbar.tab.download') }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group row">
              <label for="inputFileType" class="col-sm-4 col-form-label">{{
                $t('export.what')
              }}</label>
              <div class="col-sm-8">
                <select id="inputFileType" v-model="downloadForm.fileType" class="form-control">
                  <option>{{ $t('comments') }}</option>
                  <option>{{ $t('email') }}</option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label for="inputSite" class="col-sm-4 col-form-label">{{
                $t('filter.site_id')
              }}</label>
              <div class="col-sm-8">
                <select id="inputSite" class="custom-select" v-model="downloadForm.sites" multiple>
                  <option v-for="siteId in sites" :value="siteId" :key="siteId">
                    {{ $t('site_id.' + siteId) }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label for="inputRating" class="col-sm-4 col-form-label">{{
                $t('filter.histopad_rating')
              }}</label>
              <div class="col-sm-8">
                <select
                  id="inputRating"
                  class="custom-select"
                  v-model="downloadForm.ratings"
                  multiple
                >
                  <option>0</option>
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                  <option>5</option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label for="inputStartDate" class="col-sm-4 col-form-label">{{
                $t('timeline.start')
              }}</label>
              <div class="col-sm-8">
                <date-picker
                  id="inputStartDate"
                  v-model="downloadForm.start"
                  :value="downloadForm.start"
                  :config="config"
                  class="form-control"
                ></date-picker>
              </div>
            </div>
            <div class="form-group row">
              <label for="inputEndDate" class="col-sm-4 col-form-label">{{
                $t('timeline.end')
              }}</label>
              <div class="col-sm-8">
                <date-picker
                  id="inputEndDate"
                  v-model="downloadForm.end"
                  :value="downloadForm.end"
                  :config="config"
                  class="form-control"
                ></date-picker>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              {{ $t('cancel') }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              @click="downloadFile"
            >
              {{ $t('confirm') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import datePicker from 'vue-bootstrap-datetimepicker'
import moment from 'moment'
import { utilsMixin, sitesMixin } from '../utils/mixins'

export default {
  name: 'Navbar',
  dependencies: ['loginService', 'dataService', 'dashboardService'],
  mixins: [utilsMixin, sitesMixin],
  data() {
    return {
      datePicker: datePicker,
      moment: moment,
      dashboardTitle: '',
      dashboardForm: {
        titles: {
          fr: '',
          en: '',
        },
        config: [],
      },
      timelineId: 'timelineNav',
      start: this.$route.params.start,
      end: this.$route.params.end,
      config: {
        format: this.dateFormat,
        useCurrent: false,
        locale: this.$locale,
      },
      downloadForm: {
        fileType: this.$t('comments'),
        sites: [],
        ratings: [],
        start: this.$route.params.start
          ? moment(this.$route.params.start).format(this.dateFormat)
          : moment(new Date())
              .subtract(1, 'month')
              .format(this.dateFormat),
        end: this.$route.params.end
          ? moment(this.$route.params.end).format(this.dateFormat)
          : moment(new Date()).format(this.dateFormat),
      },
      currentDashboardId: this.$route.params.id,
      selectedTab: {},
      dashboardLocale: this.$locale,
      mapSites: [],
      surveySites: [],
      maxCharacters: 36,
    }
  },
  computed: {
    getStartDate: function() {
      return moment(this.start, this.dateFormat).format('YYYY-MM-DD')
    },
    getEndDate: function() {
      return moment(this.end, this.dateFormat).format('YYYY-MM-DD')
    },
    showSurveyForPartner: function() {
      var found = this.getCurrentUser.sites.find(s => {
        return s.has_survey
      })
      return found ? true : false
    },
    showMapForPartner: function() {
      var found = this.getCurrentUser.sites.find(s => {
        return s.has_map
      })
      return found ? true : false
    },
  },
  mounted() {
    axios.defaults.baseURL = this.$baseURL
  },
  components: {
    datePicker,
  },
  methods: {
    signOut: function() {
      this.$store.dispatch('auth/removeCurrentUser').then(() => {
        this.$router.push('/login')
      })
    },
    onCreateDashboard: function() {
      if (this.getCurrentUser.userRole.name === 'partner') {
        this.selectedTab = this.getCurrentUser.tabs[0]
      }

      let dashboard

      this.dashboardService
        .createDashboard({
          titles: this.dashboardForm.titles,
          user_id: this.getCurrentUser.id,
          rank: this.selectedTab.dashboards.length > 0 ? this.selectedTab.dashboards.length + 1 : 1,
          tab_id: this.selectedTab.id,
        })
        .then(data => {
          dashboard = data.result
          return this.loginService.getUser(this.getCurrentUser.email)
        })
        .then(user => {
          this.$store.dispatch('auth/setCurrentUser', user).then(() => {
            this.$router.push(`/dashboard/${dashboard.id}`)
          })
        })
        .catch(e => {
          console.error('Error', e)
        })
    },
    onDisplayCreationModal: function(tab) {
      this.dashboardTitle = ''
      this.selectedTab = tab
    },
    downloadFile: function() {
      let startDate = this.moment(this.downloadForm.start, 'DD/MM/YYYY').format('YYYY-MM-DD')
      let endDate = this.moment(this.downloadForm.end, 'DD/MM/YYYY').format('YYYY-MM-DD')

      if (this.getCurrentUser.userRole.name === 'partner') {
        var sites = Array.from(this.getCurrentUser.sites, site => {
          return '' + site.site_id
        })
        if (this.downloadForm.sites && this.downloadForm.sites.length > 0) {
          this.downloadForm.sites = this.downloadForm.sites.filter(id => {
            return sites.indexOf(id) > -1
          })
        } else {
          this.downloadForm.sites = sites
        }
      }

      let type = this.downloadForm.fileType == this.$t('comments') ? 'comment' : 'email'

      this.dataService.downloadFile(this.downloadForm, startDate, endDate).then(data => {
        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
          'download',
          `export_${type}_${this.$route.params.start}_${this.$route.params.end}.csv`,
        )
        document.body.appendChild(link)
        link.click()
      })
    },
    onLanguageChange: function(locale) {
      6
      this.$locale = locale
      this.$store.dispatch('prefs/setCurrentLanguage', locale).then(() => {
        this.$router.go({ path: this.$route })
      })
    },
  },
}
</script>

<style>
.navbar-overflow {
  overflow-y: auto !important;
  max-height: 100vh !important;
}
</style>
